"use client";

import Link from "next/link";
import Image from "next/image";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#1a1a1a] flex flex-col items-center justify-center px-4 py-12 relative">
      {/* Logo and Brand - Top Left */}
      <div className="absolute top-6 left-6"></div>

      {/* Main Content - Centered Container with Left-Aligned Text */}
      <div className="flex flex-col items-start justify-center text-left max-w-2xl w-full">
        <div>
          <Link
            href="/"
            className="flex items-center gap-2 hover:opacity-80 transition-opacity"
          >
            <div className="relative">
              <Image
                src="/logo-icon-transparent.png"
                alt="PineGen AI Logo"
                width={60}
                height={40}
                className="rounded-full"
                priority
              />
            </div>
            <span className="text-xl text-white">
              <span className="font-medium">PineGen</span>{" "}
              <span className="font-normal">AI</span>
            </span>
          </Link>
        </div>
        {/* 404 Not Found Heading */}
        <h1 className="text-[32px]  font-bold text-white mb-6 tracking-wider">
          404 Not Found
        </h1>

        {/* Explanatory Text */}
        <p className="text-base md:text-lg text-white/90 mb-10 max-w-xl leading-relaxed font-normal">
          The page your are looking for doesn't exit or an other error occured.
          Check out our Help Center or head back to home
        </p>

        {/* Go Back to Home Button */}
        <Link
          href="/"
          className="bg-[#59595C] hover:bg-[#333333] text-white px-8 py-3 rounded-full transition-colors duration-200 font-semibold"
        >
          Go Back to Home
        </Link>
      </div>
    </div>
  );
}
